import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox';
import Plyr from 'plyr';
import Swiper, {
    Navigation, Pagination, Autoplay, Controller, EffectFade
} from 'swiper';

import mapBox from './inc/hmMaps';
import dataStore from './inc/dataStore';
import { herrlichesMenu, mobileSubmenu, hmNavInit } from './inc/header';
import browserDetection from './inc/browserDetection';
import observeIntersection from './inc/observeIntersection';
import scriptLoader from './inc/scriptLoader';
import devAt from './inc/devAt';
import { parallaxObject, parallaxScroll } from './inc/parallaxScroll';

Swiper.use([Navigation, Pagination, Autoplay, Controller, EffectFade]);

const LazyLoad = require('vanilla-lazyload');

window.jQuery = jQuery;
window.$ = jQuery;

/* Author: herrlich media */
$(document).ready(() => {
    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Ready Inits +++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    /* browser/touch detection ++++++++++++++++++++++++++++++++++++++++++*/
    browserDetection();

    /* mapboix intersection +++++++++++++++++++++++++++++*/
    window.initMapObserver();

    /* Herrlich Media Nav Init ++++++++++++++++++++++++++++++++++++++++++*/
    hmNavInit();

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Plugins +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    /* lazy load  ++++++++++++++++++++++++++++++++++++++++++*/
    lazyloadUpdate();

    /* Ffancybox  ++++++++++++++++++++++++++++++++++++++++++*/
    Fancybox.bind(
        '.wp-block-gallery a[href$=jpg], .wp-block-gallery a[href$=png], .wp-block-gallery a[href$=webp]',
        {
            groupAll: true,
        }
    );

    Fancybox.bind(
        '.wp-block-image a[href$=jpg], .wp-block-image a[href$=png], .wp-block-image a[href$=webp]'
    );

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Eventlistener +++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    // scroll Down
    $('.scrollDown').on('click touch', () => {
        dataStore.html.stop().animate({
            scrollTop: $('#bigHeaderWrapper').offset().top + $('#bigHeaderWrapper').height() - 62
        }, 300);
    });

    // Img Teaser
    $('.imgTeaser .imgTeaser__element').on('touch mouseenter', (e) => {
        const currentIndex = $(e.currentTarget).index();
        const currentImg = $(e.currentTarget).siblings('.imgTeaser__background').find('img').eq(currentIndex);

        $(e.currentTarget).siblings('.imgTeaser__background').find('img').not(currentImg)
            .removeClass('active');
        currentImg.addClass('active');
    });

    // Job Toggle
    $('.job__title').on('click', (e) => {
        const currentContent = $(e.currentTarget).siblings('.job__content');
        const parent = $(e.currentTarget).parent();

        $('.job').not(parent).removeClass('active');
        parent.addClass('active');
        $('.job__content').not(currentContent).slideUp(450);
        currentContent.slideDown(450);
    });

    $('.job__btn').on('click', (e) => {
        const jobTitle = $(e.currentTarget).parent().siblings('.job__title').find('h3');

        $('.jobTitle input').val($(jobTitle[0]).text());
        $('.jobs__form').show();
        dataStore.html.stop().animate({
            scrollTop: $('.jobs__form').offset().top
        }, 300);
    });

    // Quick links
    const qicklinksLink = $('.quicklinks .link');
    if (qicklinksLink.length) {
        qicklinksLink.on('mouseenter', (e) => {
            $(e.currentTarget).parent().parent().siblings('.quicklinks__bg')
                .addClass(`hover${$(e.currentTarget).index()}`);
        }).on('mouseleave', (e) => {
            $(e.currentTarget).parent().parent().siblings('.quicklinks__bg')
                .removeClass(`hover${$(e.currentTarget).index()}`);
        });
    }

    $('.productCatList').on('click', (e) => {
        $(e.currentTarget).addClass('triggert');
    });

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Shop Live Search ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    if ($('.archive__search__input').length) {
        const { hostname } = window.location;

        jQuery.ajax({
            type: 'GET',
            dataType: 'json',
            url: `http://${hostname}/wp-json/products/livesearch`,
            success(results) {
                dataStore.activeLiveSearch = true;
                console.log(results);

                dataStore.products = results.products;
            }
        });

        console.log(dataStore.products);

        $('.archive__search__input').on('input propertychange', (e) => {
            if (dataStore.activeLiveSearch === true) {
                console.log('activeLiveSearch');

                const val = $(e.currentTarget).val().toLowerCase();

                if (val !== '') {
                    console.log(val);
                    console.log(dataStore.products);

                    dataStore.resultsPreview.empty();
                    dataStore.hasResult = false;

                    for (let i = 0; i < dataStore.products.length; i++) {
                        const element = dataStore.products[i];

                        if (element.title.toLowerCase().includes(val) || element.content.toLowerCase().includes(val)
                        || element.tags.indexOf(val) > -1) {
                            dataStore.hasResult = true;
                            console.log(element.title);
                            console.log(element.tags);
                            dataStore.searchRsults.push(element);

                            dataStore.resultsPreview.append(`<li><a href="${element.link}">
                            <img src="${element.thumb}" alt="${element.title}" loading="lazy"/>
                            ${element.title}</a></li>`);
                        }
                    }

                    if (dataStore.hasResult === false) {
                        dataStore.resultsPreview.append('<li>Keine Suchergebnisse</li>');
                    }
                } else {
                    // keine anzeigen / reset
                    dataStore.resultsPreview.empty();
                }
            }
        });
    }

    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Scroll ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    $(window).scroll(() => {
        dataStore.docScroll = $(window).scrollTop();

        // parallax Scroll Function
        parallaxScroll();
    });
}); /* ready end ++++++++++++++++++++++++++++++++++++++++++*/

$(window).resize(() => {
    dataStore.docWidth = $(document).width();
    dataStore.docHeight = $(document).height();
    dataStore.winHeight = $(window).height();

    $(window).trigger('scroll');

    clearTimeout(dataStore.endOfResize);
    dataStore.endOfResize = setTimeout(() => {
        afterResize();
    }, 250);
});

function afterResize() {
    mobileSubmenu();
    herrlichesMenu.destroy();
    herrlichesMenu.init();
}

$(window).on('load', () => {
    /* Swiper  ++++++++++++++++++++++++++++++++++++++++++*/

    // eslint-disable-next-line
    const headerSlider = new Swiper('.headerSlider', {
        loop: true,
        effect: 'fade',
        speed: 450,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    });

    const productsBlockSwiperSizer = $('.productsBlockSwiperSizer').width();

    let spaceBetween = 40;
    if (dataStore.docWidth < 992) {
        spaceBetween = 16;
    }
    // eslint-disable-next-line
    const productsBlockSwiper = new Swiper('.productsBlock__slider', {
        spaceBetween,
        width: productsBlockSwiperSizer,
        navigation: {
            nextEl: '.productsBlock__slider__nav .next',
            prevEl: '.productsBlock__slider__nav .prev',
        },
    });

    // Parallax Object Creare on load
    parallaxObject();

    /* developed at ++++++++++++++++++++++++++++++++++++++++++*/
    devAt();

    /* Intersection Observer  ++++++++++++++++++++++++++++++++++++++++++*/
    observeIntersection('.fadeIn', (e, intersected) => {
        if (intersected) {
            $(e.target).not('.vis').addClass('vis');
        }
    }, true);

    observeIntersection('.fadeInRow', (e, intersected) => {
        if (intersected) {
            $(e.target)
                .find('> div, > li, > p')
                .not('.vis')
                .each((i, el) => {
                    setTimeout(() => {
                        $(el).addClass('vis');
                    }, 150 * i);
                });
        }
    }, true);
});

// Lazyload Update
const lazyloadUpdate = function lazyloadUpdate() {
    if (dataStore.lazyLoadInstance !== '') {
        dataStore.lazyLoadInstance.update();
    }
};

/* Webp Support Detection  ++++++++++++++++++++++++++++++++++++++++++*/
async function supportsWebp() {
    if (!window.self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then((r) => r.blob());
    return createImageBitmap(blob).then(() => true, () => false);
}

// Add Webp to Background Imgaes when supported
(async() => {
    if (await supportsWebp()) {
        dataStore.body.addClass('webp');
        const lazyBg = document.querySelectorAll('[data-bg]');
        lazyBg.forEach((element) => {
            let { bg } = element.dataset;
            if (bg.match(new RegExp('.*(.jpg|.jpeg|.png)')) && !bg.includes('.webp') && !bg.includes('cdninstagram')) {
                bg = `${bg}.webp`;
                element.setAttribute('data-bg', bg);
            }
        });
    }

    /* lazy load  ++++++++++++++++++++++++++++++++++++++++++*/
    dataStore.lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy'
    });
    lazyloadUpdate();
})();

// eslint-disable-next-line
const initPlayers = () => {
    if (document.body.classList.contains('has-plyr')) {
        const playerContainers = Array.from(document.querySelectorAll('.videoPlayer'));
        // eslint-disable-next-line
        const players = playerContainers.map((container) => new Plyr(container));
    }
};

window.initMapObserver = () => {
    function initMap() {
        // load map script and initialize map here
        // for testing:
        scriptLoader(
            // 'themeVars' is a localized variable from WordPress
            // eslint-disable-next-line no-undef
            [`${themeVars.assetsUrl}dist/js/mapbox/mapbox-gl.js`],
            mapBox
        );
    }
    observeIntersection('.mapbox__container', initMap, true);
};

initPlayers();
